// FILE: frontend/src/pages/FAQ.tsx
import React from 'react';

const FAQ: React.FC = () => {
  const faqs = [
    {
      question: "What is AutoQuiz AI?",
      answer: "AutoQuiz AI turns a topic into a faceless quiz video with AI-generated questions, answers, explanations, voiceover, backgrounds, and rendering."
    },
    {
      question: "Do I need a subscription?",
      answer: "No. AutoQuiz AI uses prepaid credits instead of monthly subscriptions."
    },
    {
      question: "How do credits work?",
      answer: "Quiz generation and previews are free. Generating the final video currently costs 5 credits."
    },
    {
      question: "How many credits do new users receive?",
      answer: "New accounts currently receive 10 signup credits when the credit wallet is initialized."
    },
    {
      question: "Do credits reset every month?",
      answer: "No. Credits do not reset on a monthly billing cycle."
    },
    {
      question: "How do I buy more credits?",
      answer: "You can purchase a one-time 50-credit pack from the Credits page whenever you need more."
    },
    {
      question: "Do unused credits expire?",
      answer: "Unused credits remain in your account wallet and do not reset on a monthly billing cycle."
    },
    {
      question: "What happens if a render fails?",
      answer: "If credits were reserved for a render and that render fails, the reserved render credits are refunded."
    },
    {
      question: "What video formats are supported?",
      answer: "AutoQuiz AI supports 9:16, 16:9, and 1:1 video formats where available in the generator."
    },
    {
      question: "Can I customize my videos?",
      answer: "Yes. You can review your quiz and adjust supported backgrounds, voice, format, timing, and render settings."
    },
    {
      question: "Can AI-generated content contain mistakes?",
      answer: "Yes. Review generated questions, answers, and explanations before publishing or relying on them."
    },

    {
      question: "How do I contact support?",
      answer: "Email us at services@findtheideas.com for account, billing, or technical support."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold text-white mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-blue-100">
            Everything you need to know about AutoQuiz AI
          </p>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6"
            >
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 flex items-start">
                <span className="text-blue-600 dark:text-blue-400 mr-3">❓</span>
                {faq.question}
              </h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed pl-9">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-white mb-4">
            Still have questions?
          </h2>
          <p className="text-blue-100 mb-6">
            Can't find the answer you're looking for? We're here to help!
          </p>

          <a href="mailto:services@findtheideas.com"
            className="inline-block bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg hover:bg-blue-50 transition-colors duration-300"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
